import React from 'react';
import { TaskButton, TaskImage } from './';

const TaskButtonList = ({ className, options, onClick, isSelected}) => (
    <div className={`task-button-container-vertical ${className}`}>
        {options.map((option, index) => {
          return(
            <>
              <TaskButton key={index} 
                      onClick={(button) => {onClick(option.value); button.target.blur();}} 
                      selected={isSelected(option.value)}>
                  {option.label}
              </TaskButton>
            </>
        )})}

    </div>
)

export default TaskButtonList;